import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Rightcontainer from "../Components/Rightcontainer";
import Header from "../Components/Header";
import "../css/terms.css";
import axios from "axios";
import { Interweave } from "interweave";
const Shipping = () => {
  const [data, setData] = useState();

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++

  const getdata = () => {
    axios.get(baseUrl + `api/term/condition/Refund_Policy`).then((res) => {
      setData(res.data[0].Desc);
    });
  };
  useEffect(() => {
    getdata();
  }, []);

  return (
    <div>
      <div className="leftContainer mb_space">
        <div className="mt-5 py-4 px-3">
          <div className="m-3">
            <h1 className="profile_headings" style={{ color: "black" }}>Refund Policy</h1>

            <>
              <p className="p2 small_para">
                Thank you for using SKILLSONOMY Ludo. This policy outlines the terms governing refunds for in-game purchases, deposits, and withdrawals. By using our platform, you agree to this policy.
              </p>
              <p className="other_page_small_headings">
                Eligibility for Refunds:
              </p>
              <p className="p2 small_para">
                <p>
                  Deposits (In-Game Chips):
                </p>


                All deposits are non-refundable unless required by law or in cases of:

                Technical errors caused by SKILLSONOMY (e.g., duplicate charges).

                Unauthorized transactions (subject to investigation).
              </p>

              <p >
                Withdrawals (Sell Requests):
              </p>

              <p className="p2 small_para">
                Once processed, withdrawals cannot be reversed or refunded. Ensure accurate bank details before submission.
              </p>




              <p className="other_page_small_headings">
                Refund Requests:
              </p>

              <p className="p2 small_para">
                How to Request:
              </p>
              <p className="p2 small_para">
                Contact support via support@SKILLSONOMY.com or in-app chat within 48 hours of the issue.
              </p>
              <p className="p2 small_para">
                Provide proof (e.g., transaction ID, gameplay recording for disputed matches).
              </p>
              <p className="p2 small_para">
                Processing Time:
              </p>

              <p className="other_page_small_headings">
                Non-Refundable Scenarios:
              </p>
              <p className="p2 small_para">
                No refunds will be issued for.
              </p>
              <p className="p2 small_para">
                Losses in skill-based games (e.g., Ludo, Chess).
              </p>
              <p className="p2 small_para">
                User errors (e.g., incorrect withdrawal details, voluntary deposits).
              </p>
              <p className="p2 small_para">
                Account suspension due to breaches of Terms (e.g., cheating, fraud).
              </p>.


              <p className="other_page_small_headings">
                Chargebacks & Disputes :
              </p>

              <p className="p2 small_para">
                Initiating bank/Payment Gateway chargebacks may result in:
              </p>
              <p className="p2 small_para">
                Permanent account termination.
              </p>
              <p className="p2 small_para">
                Legal action to recover disputed amounts.
              </p>



              <p className="other_page_small_headings">
                Cancellations
              </p>
              <p className="p2 small_para">
                Voided Matches:
              </p>
              <p className="p2 small_para">
                Games canceled due to technical errors (with valid proof) will refund entry fees to players’ accounts.
              </p>



              <p className="other_page_small_headings">
                Governing Law
              </p>

              <p className="p2 small_para">
                Refund disputes fall under the jurisdiction of courts in Delhi, India, as per SKILLSONOMY’s Terms.


              </p>
            </>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};
export default Shipping;
